'use strict';

// Polyfills
require('./polyfills/foreach.js');

// Include theme scripts
require('./menu.js');
require('./sliders.js');
require('./modals.js');
require('./sticky-header.js');
require('./smooth-scroll.js');

// Include if doing sorting/pagination
require('./archives.js');

// Animation handler
require('./animations.js');

class Theme {
	constructor(msg) {
		console.log(msg)
	}
}

new Theme('hello')